import React from 'react'
import styled, { CSSProperties } from 'styled-components'
import { IStyleElement } from '~/types/types'
import breakpoints from './breakpoints'

interface Props extends IStyleElement {
  link?: boolean // is link or button
  color?: string
  primary?: boolean
  maxWidth?: string
  margin?: string
  border?: string
  borderColor?: string
  style?: CSSProperties
  [key: string]: any
}

const NormalButton = styled.button<Props>`
  margin: ${p => p.margin || '0'};
  height: 48px;
  border: ${p => p.border || '1px solid'};
  max-width: ${p => p.maxWidth || '90%'};
  border-color: ${props => props.borderColor || 'black'};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 15px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.color || 'black'};
  background: ${props => props.primary ? 'linear-gradient(96deg, #0099ff, #0055ff), rgba(26, 26, 26, 0.32);' : 'transparent'};
  ${p => p.xsStyle}
  ${breakpoints.sm} {
    ${p => p.smStyle}
  }
  ${breakpoints.md} {
    ${p => p.mdStyle}
    max-width: ${p => p.maxWidth || '100%'};
  }
  ${breakpoints.lg} {
    ${p => p.lgStyle}
  }
  ${breakpoints.xl} {
    ${p => p.xlStyle}
  }
`

const Link = styled.a<Props>`
  margin: ${p => p.margin || '0'};
  text-decoration: none !important;
  width: 100%;
  max-width: ${p => p.maxWidth || '320px'};
  height: 48px;
  border: ${p => p.border || '1px solid'};
  border-color: ${props => props.borderColor || 'black'};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 15px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.color || 'black'};
  background: ${props => props.primary ? 'linear-gradient(96deg, #0099ff, #0055ff), rgba(26, 26, 26, 0.32);' : 'transparent'};
  ${p => p.xsStyle}
  ${breakpoints.sm} {
    ${p => p.smStyle}
  }
  ${breakpoints.md} {
    ${p => p.mdStyle}
    max-width: ${p => p.maxWidth || '320px'};
  }
  ${breakpoints.lg} {
    ${p => p.lgStyle}
  }
  ${breakpoints.xl} {
    ${p => p.xlStyle}
  }

`
const Button: React.FC<Props> = ({ link = false, ...rest }) => {
  if (link) {
    return <Link {...rest} />
  }
  return <NormalButton {...rest} />
}

export default Button